// Find & Replace Tool — replace text with literal or regex matching.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const findReplaceTool: Tool = {
  id: "find-replace",
  name: () => m.fr_tool_name(),
  description: () => m.fr_tool_description(),
  icon: "🔎",
  basePath: "/find-replace",
  status: "stable",
  tags: ["text", "replace", "regex", "developer"],
  pages: [
    {
      name: () => m.fr_nav_main(),
      path: "/find-replace",
      description: () => m.fr_nav_main_desc(),
      icon: "🔎",
    },
  ],
};
